<script>
  import {sgettext} from '../../i18n.js';
  export let title = sgettext('$$RELATED_ACTIVITIES$$');
  export let data = {results: []};

  function getStatus(row) {
    let status = sgettext(row.template_status);

    if (!row.template) {
      if (row.expired) {
        status = sgettext('$$EXPIRED$$');
      } else if (row.end_time) {
        status = sgettext('$$COMPLETED$$');
      } else if (row.start_time) {
        status = sgettext('$$PROGRESS$$');
      } else {
        status = sgettext('$$NOT_STARTED$$');
      }
      
    }
    return status;
  }
  
  function getUrl(id){
    return`${location.protocol}//${location.host}/sw/builder/activityversion/${id}/detail/`;
  }
</script>

<style>
  .related-activities {
    margin-top: 30px;
    border: 1px solid #e9edef;
  }

  section header {
    padding: 10px 15px;
    background-color: #e9edef;
  }
  section header h4 {
    margin: 0;
  }
  section .detail {
    padding: 15px;
    height: 350px;
    overflow-y: auto;
  }

  thead tr {background-color: rgba(225, 225, 225, 0.3);}

  tbody tr:nth-child(even) {
    background-color: rgba(225, 225, 225, 0.2);
  }

  .detail table {width: 100%;}

  .detail a:hover {text-decoration: none;}

  ::-webkit-scrollbar
  {
    width: 6px;  /* for vertical scrollbars */
    height: 6px; /* for horizontal scrollbars */
  }

  ::-webkit-scrollbar-track
  {
    background: rgba(0, 0, 0, 0.1);
  }

  ::-webkit-scrollbar-thumb
  {
    background: rgba(0, 0, 0, 0.3);
  }
</style>

<section class="related-activities">
  <header>
    <h4>{title}</h4>
  </header>
  <div class="detail">
    <table>
      <thead>
        <tr>
          <th>{sgettext('$$NAME$$')}</th>
          <th>{sgettext('$$TYPE$$')}</th>
          <th>{sgettext('$$STATUS$$')}</th>
        </tr>
      </thead>
      <tbody>
        {#each data.results as row}
          <tr>
            <td><a href={getUrl(row.id)} target="_blank" rel="noopener noreferrer">{row.name}</a></td>
            <td>{row.template ? sgettext('$$TEMPLATE$$') : sgettext('$$INSTANCE$$')}</td>
            <td>{getStatus(row)}</td>
          </tr>
        {/each}
      </tbody>
    </table>
  </div>

</section>
